var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 19,
    viewBox: "0 0 16 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.34766 1.9375C6.24219 1.9375 6.17188 2.00781 6.10156 2.07812L5.43359 3.0625H10.5312L9.86328 2.07812C9.82812 2.00781 9.72266 1.9375 9.61719 1.9375H6.34766ZM12.5703 3.0625H13.0273H14.75H15.0312C15.4883 3.0625 15.875 3.44922 15.875 3.90625C15.875 4.39844 15.4883 4.75 15.0312 4.75H14.6094L13.7656 16.1758C13.6602 17.3711 12.7109 18.25 11.5156 18.25H4.44922C3.25391 18.25 2.30469 17.3711 2.19922 16.1758L1.35547 4.75H0.96875C0.476562 4.75 0.125 4.39844 0.125 3.90625C0.125 3.44922 0.476562 3.0625 0.96875 3.0625H1.25H2.9375H3.39453L4.69531 1.12891C5.04688 0.601562 5.67969 0.25 6.34766 0.25H9.61719C10.2852 0.25 10.918 0.601562 11.2695 1.12891L12.5703 3.0625ZM12.9219 4.75H3.04297L3.88672 16.0703C3.92188 16.3516 4.16797 16.5625 4.44922 16.5625H11.5156C11.7969 16.5625 12.043 16.3516 12.0781 16.0703L12.9219 4.75Z",
    fill: "#D8D8D9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteDark);
export default __webpack_public_path__ + "static/media/delete_dark.5c692f30f17e2dfb2dc13af2d399a04c.svg";
export { ForwardRef as ReactComponent };